import type { CSSProperties, ReactNode } from 'react';

export function Card({
  children,
  className,
  style,
}: {
  children: ReactNode;
  className?: string;
  /** Inline overrides — used by TripCard's `isNext` to swap the border colour
   *  and box-shadow to the elevated treatment without losing the base classes. */
  style?: CSSProperties;
}) {
  return (
    <div
      className={[
        'bg-[var(--color-surface)] border border-[var(--color-border)] p-4',
        'rounded-[var(--radius-card)] shadow-[var(--shadow-card)]',
        className || '',
      ].join(' ')}
      style={style}
    >
      {children}
    </div>
  );
}
